<div class="mag-table-container">

  <table mat-table [dataSource]="detailMags" class="mag-table">

    <ng-container matColumnDef="magasin">
      <th mat-header-cell *matHeaderCellDef> Magasin</th>
      <td mat-cell *matCellDef="let element"> {{ element.location__magasin__label }}</td>
    </ng-container>

    <ng-container matColumnDef="batiment">
      <th mat-header-cell *matHeaderCellDef> Batiment</th>
      <td mat-cell *matCellDef="let element"> {{ element.location__magasin__batiment__label }}</td>
    </ng-container>

    <ng-container matColumnDef="etage">
      <th mat-header-cell *matHeaderCellDef> Etage</th>
      <td mat-cell *matCellDef="let element"> {{ element.location__magasin__etage__label }}</td>
    </ng-container>

    <ng-container matColumnDef="metrageTotal">
      <th mat-header-cell *matHeaderCellDef> Total</th>
      <td mat-cell *matCellDef="let element"> {{ element.location__magasin__metrage }}m.</td>
    </ng-container>

    <ng-container matColumnDef="metrageLibre">
      <th mat-header-cell *matHeaderCellDef> Libre</th>
      <td mat-cell *matCellDef="let element"> {{ dashboardSvc.metrageLibre(element) }}m.</td>
    </ng-container>

    <ng-container matColumnDef="metrageOccupe">
      <th mat-header-cell *matHeaderCellDef> Occupé</th>
      <td mat-cell *matCellDef="let element"> {{ dashboardSvc.metrageOccupe(element) }}m.</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons></mat-paginator>
</div>
